import React from 'react';
import { useLoading } from '../util/LoadingContext'; // Adjust the path as necessary
import { ProgressSpinner } from 'primereact/progressspinner';

const LoadingSpinner: React.FC = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null; // Don't render anything if not loading

  return <div className="tw-h-dvh tw-w-screen tw-bg-white tw-flex tw-justify-center tw-items-center tw-fixed tw-top-0 tw-left-0 tw-z-50">
  <ProgressSpinner />
</div>; // Customize your loading spinner as needed
};

export default LoadingSpinner;
